<template>
  <div class="card executive-card mb-4">
    <div class="card-header section-header border-0 pt-3 pb-0 px-3">
      <h5 class="section-title">Performance por Cultivar</h5>
      <span class="section-badge">Top Recomendacoes</span>
    </div>
    <div class="card-body pt-2">
      <apexchart type="bar" height="280" :options="chartOptions" :series="chartSeries" />
      <div class="mt-2">
        <div v-for="item in items" :key="item.name" class="d-flex justify-content-between cultivar-line">
          <span class="cultivar-name">{{ item.name }}</span>
          <span :class="item.growth >= 0 ? 'trend-up' : 'trend-down'">
            {{ item.growth >= 0 ? '↑' : '↓' }} {{ Math.abs(item.growth).toFixed(1) }}%
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExecutiveCultivarSection',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chartSeries() {
      return [{ name: 'Receitas', data: this.items.map((item) => item.receitas) }]
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 6,
            distributed: true,
          },
        },
        dataLabels: { enabled: false },
        colors: ['#1a8f5b', '#127a64', '#0d6079', '#19496b'],
        xaxis: {
          categories: this.items.map((item) => item.name),
          labels: {
            style: {
              colors: '#5a7085',
            },
          },
        },
        grid: {
          borderColor: '#e6eef4',
        },
      }
    },
  },
}
</script>

<style scoped>
.executive-card {
  border: 1px solid #d8e5ec;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(9, 32, 58, 0.08);
}

.section-header {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f2b40;
}

.section-badge {
  border-radius: 999px;
  border: 1px solid #c8dae8;
  background: #f0f7fb;
  padding: 4px 10px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: #2f5771;
}

.cultivar-line {
  font-size: 13px;
  padding: 7px 0;
  color: #2e4960;
  border-bottom: 1px dashed #e5edf3;
}

.cultivar-name {
  font-weight: 600;
}

.trend-up {
  color: #0d7a3f;
  font-weight: 700;
}

.trend-down {
  color: #b43735;
  font-weight: 700;
}
</style>
